<template>
    <el-dialog
            width="30%"
            title="添加电话黑名单"
            :modal="false"
            @close="close()"
            :visible="true"
            :close-on-click-modal="false"
            class="close">
        <el-form label-width="100px" size="mini">
            <el-form-item label="电话号码:" required>
                <el-input v-model="formPost.phone"></el-input>
            </el-form-item>
            <el-form-item label="备注:" required>
                <el-input v-model="formPost.memo"></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer">
            <el-button size="mini" @click="close()" title="取消">取 消</el-button>
            <el-button size="mini" type="primary" @click="handleConfirm()" title="确定提交">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        props: {

        },
        watch: {

        },
        data() {
            return {
                formPost: {
                    phone: '',
                    memo: '',
                },
                TmpOptions: [],
            }
        },
        mounted() {
        },
        methods: {
            handleConfirm() {
                let that = this
                this.$ajax.post('admin/Blacklist/add', this.formPost).then(function (res) {
                    if (res.data.error === 0) {
                        that.$emit('callback', true)
                    } else {
                        that.$message(res.data.message)
                    }
                })
            },
            close() {
                this.$emit('callback', false)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/page/xpqd/Add.vue